module.exports = __webpack_public_path__ + "static/media/c4_3.a215cec6.png";